// 菜单
export default {
    dashboard: 'Home',
    flight: 'Flight Manage',
    department: 'Department Manage',
    user: 'User',
    userManage: 'User Manage',
    userReview: 'User Review',
    role: 'Role Manage',
    group: 'Group Manage',
    log: 'Log Manage',
    taskManage: 'Task Manage',
    allTasks: 'All Tasks',
    myTask: 'My Task',
    taskConfig: 'Task Config',
    addTaskSpot: "Add point reconnaissance",
    addTaskArea: "Add regional reconnaissance",
    addTaskOrthophoto: "Add orthophoto",
    addTaskObliquePhotography: "Add tilt photography",
    addTaskLogistics: "Add logistics transportation",

    editTaskSpot: "Edit point reconnaissance",
    editTaskArea: "Edit regional reconnaissance",
    editTaskOrthophoto: "Edit orthophoto",
    editTaskObliquePhotography: "Edit tilt photography",
    editTaskLogistics: "Edit logistics transportation",

    approval: 'Approval Manage',
    autoApproval: 'Automatic Approval',
    noFlyZone: 'No-fly zone Manage',
    addNoFlyZone: 'Add no-fly zone',
    editNoFlyZone: 'Edit no-fly zone',
    noFlyZoneLifted: 'No fly zone lifted',
    globalFence: 'Global electronic fence',
    boundaryAlarm: 'Boundary crossing alarm record',
    device: 'Device Manage',
    newsPush: 'News Push',
    corporateInformation: 'Corporate Information',

    // button
    query: 'Query',
    add: 'Add',
    edit: 'Edit',
    delete: 'Delete',
    personnel: 'Personnel Manage',
    freezeRecovery: 'Freeze/Recovery',
    legalize: 'Legalize',
    check: 'Check',
    submit: 'Submit',
    release: 'Release',
    revoke: 'Revoke',
    results: 'Results',
    report: 'Generate report',
    recover: 'Recover',
    mapView: 'Map View',
    pass: 'Pass',
    fail: 'Fail',
    automaticApprovalSet: 'Auto Approval Settings',
    validInvalid: 'Valid/Invalid',
    invalid: 'Invalid',
    details: 'Details',
    permission: 'Permission',
    addNews: 'New message',
    upload: 'Upload',
}